export default __webpack_public_path__ + "static/media/item-2-mob.4bc7ef00.png";